<template>
  <div>
    <h5 class="content-block">Pegawai List</h5>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          class="dx-card wide-card"
          id="dataGrid"
          :data-source="dataSource"
          :focused-row-index="0"
          :show-borders="true"
          :show-column-lines="false"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          :allow-column-reordering="true"
          @exporting="onExporting"
        >
          <dx-paging :page-size="10" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <dx-filter-row :visible="true" />

          <DxExport :enabled="true" :allow-export-selected-data="true" />
          <DxSelection mode="multiple" />
          <DxColumnFixing :enabled="true" />
          <DxToolbar>
            <DxItem name="groupPanel" />
            <DxItem location="after" template="button-template" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>
          <template #button-template>
            <DxButton text="Import data" :width="136" @click="importClick" />
          </template>
          <dx-column
            data-field="nama"
            caption="Pegawai"
            :allow-sorting="true"
            :fixed="true"
            fixed-position="left"
          />

          <dx-column
            data-field="job_histories[0].cabang_id"
            caption="Cabang"
            :allow-sorting="true"
          >
            <DxLookup
              :data-source="cabangSource"
              value-expr="id"
              display-expr="nama"
            />
          </dx-column>

          <dx-column
            data-field="job_histories[0].jabatan_id"
            caption="Jabatan"
            :allow-sorting="true"
          >
            <DxLookup
              :data-source="jabatanSource"
              value-expr="id"
              display-expr="nama"
            />
          </dx-column>
          <dx-column
            data-field="job_histories[0].bagian_id"
            caption="Bagian"
            :allow-sorting="true"
          >
            <DxLookup
              :data-source="bagianSource"
              value-expr="id"
              display-expr="nama"
            />
          </dx-column>

          <dx-column
            data-field="job_histories[0].sub_bagian_id"
            caption="Sub Bagian"
            :allow-sorting="true"
          >
            <DxLookup
              :data-source="subBagianSource"
              value-expr="id"
              display-expr="nama"
            />
          </dx-column>

          <dx-column
            data-field="job_histories[0].golongan_id"
            caption="Golongan"
            :allow-sorting="true"
          >
            <DxLookup
              :data-source="golonganSource"
              value-expr="id"
              display-expr="nama"
            />
          </dx-column>

          <dx-column
            data-field="alamat"
            caption="Alamat"
            :allow-sorting="true"
          />

          <dx-column data-field="telp" caption="Telp" :allow-sorting="true" />

          <dx-column
            data-field="agama_id"
            caption="Agama"
            :allow-sorting="true"
          >
            <DxLookup
              :data-source="agamaSource"
              value-expr="id"
              display-expr="nama"
            />
          </dx-column>
          <!-- <dx-column
            data-field="job_histories[0].cabang_id"
            caption="Cabang"
            :allow-sorting="true"
            cell-template="cabang-cell-template"
          /> -->

          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="id"
            caption=" "
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              :items="options"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClick"
            />
          </template>

          <!-- <template #cabang-cell-template="{ data }">
            {{ getCabang(data.value) }}
          </template> -->
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
/* eslint-disable */
import _ from "lodash";
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxPager,
  DxPaging,
  // DxEditing,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxButton,
  DxToolbar,
  DxItem,
  DxLookup,
} from "devextreme-vue/data-grid";
import notify from "devextreme/ui/notify";
import DxDropDownButton from "devextreme-vue/drop-down-button";
// eslint-disable-next-line
import router from "@/router";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver"; 

import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";

// const cabangStore = new ODataStore({
//   type: "odata",
//   url: "http://127.0.0.1/odata/Cabangs",
//   key: "id",
//   version: 4,
//   beforeSend: function (e) {
//     console.log(e);
//     e.headers = {
//       "odata-version": "4.0",
//     };
//   },
// });

// url: "http://127.0.0.1:8000/odata/LodataMasters?$expand=lodata_details",
const pegawaiStore = new ODataStore({
  type: "odata",

  // url: "http://127.0.0.1/odata/Pegawais?$filter=job_histories/any(s:s/status eq 1)&$expand=job_histories($filter=status eq 1)",
  url: "http://127.0.0.1/odata/Pegawais?&$expand=job_histories($filter=status eq 1)",
  key: "id",
  version: 4,
  // sort: ["nama", { selector: "nama", desc: true }],
  // expand: "lodata_details",
  beforeSend: function (e) {
    e.headers = {
      "odata-version": "4.0",
    };
    // e.params.$orderby = "nama desc";
    // var string = _.replace(e.params.$filter, "[0]", "");
    // // e.params.$filter = "contains(tolower(lodata_details/nama),'a')";
    // e.params.$filter = string;

    /*
      FILTER
      asli filter devextreme and (job_histories[0]/cabang_id eq 1)
      ^^ ini akan error!
      if job_histories[0] --> replace dengan job_histories/any(s:s/
      lalu split asli dengan /, ambil array kedua dari hasil split 
      kemudian append ke job_histories/any(s:s/

      lalu replace asli dengan append

    */

    console.log("*****FILTERASLI****");
    console.log(e.params.$filter);
    if (typeof e.params.$filter !== "undefined") {
      // var string = _.replace(e.params.$filter, "[0]", "");
      var splitAnd = _.split(e.params.$filter, "and").map(_.trim);
      // console.log(splitAnd); //split between and
      var jobFilter = ["j/status eq 1"];

      // splitAnd.forEach(function(element, index) {
      //   console.log(element);

      //   if(_.includes(element, 'job_histories[0]')){
      //     //ambil field yang difilter
      //     var splitSlash = _.split(element, "/");
      //    field.push(splitSlash[1]);
      //    splitAnd[index] = '';
      //   }
      // });

      _.forEach(splitAnd, function (element) {
        if (_.includes(element, "job_histories[0]")) {
          //ambil field yang difilter
          var string = _.replace(element, ")", "");
          string = _.replace(string, "(", "");
          var splitSlash = _.split(string, "/");
          jobFilter.push("j/" + splitSlash[1]);
          _.remove(splitAnd, element); //-->element ga mau di remove
        }
      });

      const filteredArray = _.filter(splitAnd, function (item) {
        if (_.includes(item, "job_histories[0]")) {
        } else return item; //pake ini karena element splitand ga bisa di remove
      });

      console.log(jobFilter);
      console.log(filteredArray);

      var filterTemp = _.join(filteredArray, " and ");
      console.log("filterTemp " + filterTemp);
      if (filterTemp == "")
        var filterJobHistories =
          "(job_histories/any(j:" + _.join(jobFilter, " and ") + "))";
      else
        var filterJobHistories =
          " and (job_histories/any(j:" + _.join(jobFilter, " and ") + "))";
      console.log("filterJob " + filterJobHistories);
      console.log("FILTERAKHIR " + filterTemp + filterJobHistories);
      e.params.$filter = filterTemp + filterJobHistories;
    }
  },

  onLoaded: () => {
    // Event handling commands go here
  },
});

const pegawaiDataSource = new DataSource({
  store: pegawaiStore,
  // expand: "job_histories",
  // sort: "nama",
  // select: [
  //         'id',
  //         'nama',
  //         'job_histories/cabang_id',

  //       ],
  dataGridRefName: "dataGrid",

  // filter: ["job_histories/any(s:s/status" , '=', "1)"],
  // select: ["id", "nama", "lodata_details.nama"],

  // sort: "nama",
});

// const cabangDataSource = new DataSource({
//   store: cabangStore,
// });

const options = ["Detail", "Transfer", "Resign", "Delete"];

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxFilterRow,

    DxPager,
    DxPaging,
    // DxEditing,
    DxColumnFixing,
    DxButton,
    DxDropDownButton,
    DxExport,
    DxSelection,
    DxToolbar,
    DxLookup,
    DxItem,
  },
  data() {
    return {
      events: [],
      dataSource: pegawaiDataSource,
      cabangSource: new ODataStore({
        url: "http://127.0.0.1/odata/Cabangs",
        key: "id",
      }),
      jabatanSource: new ODataStore({
        url: "http://127.0.0.1/odata/Jabatans",
        key: "id",
      }),
      bagianSource: new ODataStore({
        url: "http://127.0.0.1/odata/Bagians",
        key: "id",
      }),
      subBagianSource: new ODataStore({
        url: "http://127.0.0.1/odata/SubBagians",
        key: "id",
      }),
      golonganSource: new ODataStore({
        url: "http://127.0.0.1/odata/Golongans",
        key: "id",
      }),
      agamaSource: new ODataStore({
        url: "http://127.0.0.1/odata/Agamas",
        key: "id",
      }),
      options: options,
      router: router,
    };
  },
  methods: {
    getCabang(index) {
      // console.log(index);
      // console.log(cabangStore)
      //  const coba = _.find(this.cabangs, { id: index });
      // return coba.nama;
    },
    dataEx() {
      console.log(this.pegawaiDataSource);
    },
    importClick() {
      this.router.push({
        name: "practice-sheetjs",
        query: { table: "pegawai" },
      });
    },
    logEvent(eventName) {
      this.events.unshift(eventName);
    },
    clearEvents() {
      this.events = [];
    },

    onSaving(e) {
      console.log(e);
    },
    myCommand(e) {
      console.log(e);
      alert("command");
    },
    onItemClick(e) {
      console.log(e.element.id);
      let pegawaiId = e.element.id;
      notify(e.itemData.name || e.itemData, "success", 600);
      this.router.push({
        name: "navigation-menu-edit",
        query: { id: pegawaiId },
      }); //?id=1
      // this.router.push({ name: "tab-treeview", params: { id: pegawaiId } }); //id tak terlihat di url
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Employees");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar Pegawai.xlsx"
          );
        });
      });
      e.cancel = true;
    },
  },
};

const cabangs = [
  { id: 1, nama: "Pusat" },
  { id: 2, nama: "Gerokgak" },
  { id: 3, nama: "Busungbiu" },
  { id: 4, nama: "Seririt" },
  { id: 5, nama: "Lovina" },
  { id: 6, nama: "Kubutambahan" },
  { id: 7, nama: "Sambirenteng" },
];

// const bagians = [
//   { name: "Litbang", value: "Litbang" },
//   { name: "Produksi", value: "Produksi" },
//   { name: "Distribusi", value: "Distribusi" },
//   { name: "Akuntansi", value: "Akuntansi" },
//   { name: "Keuangan", value: "Keuangan" },
//   { name: "Personalia", value: "Personalia" },
// ];

// const subBagians = [{ name: "TI", value: "TI" }];

// const jabatans = [
//   { name: "Kabag", value: "Kabag" },
//   { name: "Kasubag", value: "Kasubag" },
//   { name: "Staf", value: "Staf" },
//   { name: "Direktur Utama", value: "Direktur Utama" },
// ];

// const golongans = [
//   { name: "A1", value: "A1" },
//   { name: "B1", value: "B1" },
//   { name: "C1", value: "C1" },
// ];

// const statuss = [
//   { name: "Pegawai Tetap", value: "Pegawai Tetap" },
//   { name: "Calon Pegawai", value: "Calon Pegawai" },
//   { name: "Kontrak", value: "Kontrak" },
//   { name: "Training", value: "Training" },
// ];

// const agamas = [
//   { name: "Hindu", value: "Hindu" },
//   { name: "Islam", value: "Islam" },
//   { name: "Buddha", value: "Buddha" },
// ];
</script>
